module.exports = __webpack_public_path__ + "img/2.9e8691a9.png";